import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
function SwiperCarasoul({ data, classes }) {

  const validateData = Array.isArray(data) ? data : [];

  if (validateData.length === 0) {
    return <p className="text-center text-gray-500 ">No images available</p>;
  }

  return (
    <>
      <Swiper
        navigation={true}
        pagination={true}
        modules={[Navigation, Pagination]}
        className="mySwiper"
      >
        {validateData?.map((el, index) => (
          <SwiperSlide key={index}>
            <div className={`${classes} h-[10.5rem] `}>
              <img
                src={`https://zv.shellcode.cloud/upload/${el}`}
                alt="Not found"
                className="rounded-lg"
                loading="lazy"
                placeholder="https://your-placeholder-url.com/placeholder-image.jpg"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}

export default SwiperCarasoul;
